import { Button, CardHeader, clx, icon } from "@hm/fundamental"

interface SectionInfoHeaderProps {
	title: string
	className?: string
	"data-cy"?: string
	"data-cy-button"?: string
	buttonTitle?: string
	onClick?: () => void
}

export const SectionInfoHeader: React.FC<SectionInfoHeaderProps> = ({
	"data-cy": dataCy,
	"data-cy-button": dataCyButton,
	title,
	className,
	buttonTitle,
	onClick,
}) => (
	<CardHeader
		data-cy={dataCy}
		className={clx(
			"!text-wrap xs:w-[calc(100%-70px)] xl:w-auto",
			className,
		)}
		aside={
			<Button
				data-cy={dataCyButton}
				variant="tertiary"
				icon={icon.mdiInformationOutline}
				onClick={onClick}
			>
				<span className="xl:block xs:hidden">{buttonTitle}</span>
			</Button>
		}
	>
		{title}
	</CardHeader>
)
